"use client"

import TopNavBar from '../TopNavBar'

export default function TopHeader() {
  return <TopNavBar />
}